/**
 * @license
 * Copyright (c) 2021 Handsoncode. All rights reserved.
 */
import { ArgumentTypes, FunctionPlugin } from './FunctionPlugin';
export class AbsPlugin extends FunctionPlugin {
    abs(ast, formulaAddress) {
        return this.runFunction(ast.args, formulaAddress, this.metadata('ABS'), Math.abs);
    }
}
AbsPlugin.implementedFunctions = {
    'ABS': {
        method: 'abs',
        parameters: [
            { argumentType: ArgumentTypes.NUMBER }
        ]
    },
};
